module.exports = __webpack_public_path__ + "static/media/go.872e5e4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/go.svg
// module id = 45
// module chunks = 0